export class BackupZeroEtlOrderingSpec {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "strategy",
            "baseName": "strategy",
            "type": "BackupZeroEtlOrderingStrategy",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlOrderingSpec.attributeTypeMap;
    }
    constructor() {
    }
}
